'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import MobileNestedMenu, { CaretForward } from '../Modals/FullScreenModal/MobileNestedMenu';
import UIButton from 'UIComponents/button/UIButton';
import styled from 'styled-components';
import { EERIE } from 'HubStyleTokens/colors';
import { FILTER_TYPES_OTHER } from '../../constants/TopFilterConstants';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIFlex from 'UIComponents/layout/UIFlex';
import I18n from 'I18n';
import { useSearchParamSingleSelect } from '../../hooks/searchParamHooks';
import UsageTracker from '../../utils/UsageTracker';
import { PanelSection } from '../../components/Modals/FullScreenModal/PanelSection';
import { Fragment } from 'react';
const MenuButton = styled(UIButton).withConfig({
  displayName: "MobileCatalogSelector__MenuButton",
  componentId: "ha3gyi-0"
})(["display:flex;flex-grow:1;justify-content:space-between;font-weight:initial;padding:12px 20px !important;"]);

const MobileCatalogSelector = (_ref) => {
  let {
    categories,
    hsSoftwareCategories,
    menuOpen,
    selectedFilterType,
    selectedGroup,
    setMenuOpen
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["categories", "hsSoftwareCategories", "menuOpen", "selectedFilterType", "selectedGroup", "setMenuOpen"]);

  const filterTypeCategories = FILTER_TYPES_OTHER.CATEGORIES;
  const filterTypeTools = FILTER_TYPES_OTHER.TOOLS;
  const [__, setCatalogFilter] = useSearchParamSingleSelect();

  const trackFilterSelect = (selectedOption, filterType) => {
    UsageTracker.track('filterInteraction', {
      action: 'filter-selected',
      value: selectedOption,
      key: filterType,
      isDropdown: true
    });
  };

  const onClickOption = (selectedOption, filterType) => {
    setCatalogFilter(filterType, selectedOption);
    trackFilterSelect(selectedOption, filterType);
    setMenuOpen(false);
  };

  const renderLevel2Items = (category, filterType) => {
    return category.map(subcat => {
      return /*#__PURE__*/_jsx(UIFlex, {
        children: /*#__PURE__*/_jsx(MenuButton, {
          "data-test-id": `option-${subcat}`,
          onClick: () => {
            onClickOption(subcat, filterType);
          },
          use: "unstyled",
          children: I18n.text(`learningCenter.topFilters.${filterType}.${subcat}`)
        })
      }, subcat);
    });
  };

  const renderCategoryHeading = (index, filterType) => {
    return /*#__PURE__*/_jsx(PanelSection, {
      showBorders: false,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}group.${index}`
      })
    });
  };

  const getSubPage = (category, index, filterType) => {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [renderCategoryHeading(index, filterType), renderLevel2Items(category, filterType)]
    });
  };

  const renderLevel1Items = (items, filterType) => {
    return items.map((category, index) => /*#__PURE__*/_jsxs(MenuButton, {
      "data-test-id": `option-${index}`,
      onClick: typeof category === 'object' ? null : () => {
        onClickOption(index, filterType);
      },
      subpage: typeof category === 'object' ? getSubPage(category, index, filterType) : null,
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: typeof category === 'object' ? `learningCenter.topFilters.${filterType}group.${index}` : `learningCenter.topFilters.${filterType}.${index}`
      }), typeof category === 'object' && /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(CaretForward, {
          color: EERIE
        })
      })]
    }, index)).toArray();
  };

  const getIndexOfSelectedGroup = categoryGroups => {
    return categoryGroups.keySeq().findIndex(k => k === selectedGroup);
  };

  const getSelectedPageIndex = () => {
    if (selectedGroup) {
      return selectedFilterType === filterTypeCategories ? getIndexOfSelectedGroup(categories) + 1 : getIndexOfSelectedGroup(hsSoftwareCategories) + categories.size + 2;
    }

    return -1;
  };

  return /*#__PURE__*/_jsxs(MobileNestedMenu, Object.assign({
    indented: false,
    open: menuOpen,
    selectedPage: getSelectedPageIndex(),
    setIsOpen: setMenuOpen,
    useBackText: false
  }, restProps, {
    children: [/*#__PURE__*/_jsx(PanelSection, {
      showBorders: false,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.categories.categories"
      })
    }), renderLevel1Items(categories, filterTypeCategories), /*#__PURE__*/_jsx(PanelSection, {
      showBorders: false,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.categories.hubspotSoftware"
      })
    }), renderLevel1Items(hsSoftwareCategories, filterTypeTools)]
  }));
};

MobileCatalogSelector.propTypes = {
  categories: ImmutablePropTypes.map.isRequired,
  hsSoftwareCategories: ImmutablePropTypes.map.isRequired,
  menuOpen: PropTypes.bool,
  selectedFilterType: PropTypes.string,
  selectedGroup: PropTypes.string,
  setMenuOpen: PropTypes.func
};
export default MobileCatalogSelector;